<script lang="ts">
  import type { RadioType } from '$src/types/forms';

  let {
    id,
    name,
    required,
    background,
    attributes,
    value,
    group = $bindable(null),
    onChange,
    label,
  }: RadioType = $props();
</script>

<div class="flex flex-col gap-1">
  <label for={id} class="gap-16px text-14px flex">
    <input
      type="radio"
      {id}
      {name}
      {required}
      {value}
      checked={value === group}
      onchange={onChange}
      {...attributes}
      data-background={background}
      class={`checked:before:bg-primary 2xl:checked:before:fluid-w-[12] 2xl:checked:before:fluid-h-[12] 2xl:fluid-w-[20] 2xl:fluid-h-[20] k relative h-5 w-5 shrink-0 appearance-none rounded-full border-1 bg-cover bg-no-repeat checked:before:absolute checked:before:top-[50%] checked:before:left-[50%] checked:before:h-[12px] checked:before:w-[12px] checked:before:-translate-x-[50%] checked:before:-translate-y-[50%] checked:before:rounded-full ${background === 'black' ? 'border-white-600 checked:border-primary' : 'border-black-1000 checked:border-black-1000'}`}
    />

    <span class="text-[var(--text-color)]">{label}</span>
  </label>
</div>
